module.exports = __webpack_public_path__ + "static/paris-023-bcc756d6edd657ae92f2e033d848fcbc.jpg";